/**
 * Feature Release Manager — API Configuration
 *
 * Recommended: set these in .env.local (or CI/CD secrets):
 *   REACT_APP_RELEASE_API_BASE_URL  — e.g. https://your-api-gateway.amazonaws.com/dev
 *   REACT_APP_RELEASE_API_KEY       — the x-api-key value
 *
 * If not set, dev-only fallbacks are used with a console warning.
 */

const DEV_FALLBACK_URL = "https://ubhe2r5kn2.execute-api.ap-south-1.amazonaws.com/dev";
const DEV_FALLBACK_KEY = "cndALcQbZL3UqAu994QmU3h3DC178wOt4mWnTfiH";

export const API_BASE_URL = (() => {
    const url = process.env.REACT_APP_RELEASE_API_BASE_URL;
    if (!url) {
        console.warn(
            "[ReleaseTracking] REACT_APP_RELEASE_API_BASE_URL is not set. " +
            "Using dev fallback. Add it to .env.local for production."
        );
        return DEV_FALLBACK_URL;
    }
    return url;
})();

export const API_KEY = (() => {
    const key = process.env.REACT_APP_RELEASE_API_KEY;
    if (!key) {
        console.warn(
            "[ReleaseTracking] REACT_APP_RELEASE_API_KEY is not set. " +
            "Using dev fallback. Add it to .env.local for production."
        );
        return DEV_FALLBACK_KEY;
    }
    return key;
})();

export const HEADERS = {
    "x-api-key": API_KEY,
    "Content-Type": "application/json",
};

/** Release lifecycle statuses */
export const RELEASE_STATUS = {
    DRAFT: "DRAFT",
    READY: "READY",
    RELEASED: "RELEASED",
};

/** Feature rollout types */
export const RELEASE_TYPE = {
    GENERIC: "GENERIC",
    CLIENT: "CLIENT",
};
